module.exports = __webpack_public_path__ + "asos.svg?05cb75cab8e6c11ab8623bc3a192d0a8";